import { lazy } from "react"

const StatisticsPage$$__react__lazy__component = lazy(() => 
    import("./StatisticsPage__original__module.mjs")
        .then(module => module.get_$$StatisticsPage$$StatisticsPage$$react__component$$2foxgvjvqedut())
        .then(component => ({ default: component }))
)

export const get_$$StatisticsPage$$StatisticsPage$$react__component$$2foxgvjvqedut = () => StatisticsPage$$__react__lazy__component